import BaseSpeedRun from "./BaseSpeedRun.js";
import { getFlagPath, renderFlagDuelError } from "../utils/FlagUtils.js";

export default class FlagNerdSpeedRun extends BaseSpeedRun {
    constructor() {
        super('flagnerd.speedrun', '.flag-nerd-speed-run', {
            passportStamp: "flag",
            gameNameKey: "home.flagNerd",
            modeLabelKey: "home.speedRun",
            slug: "flag-nerd-speed-run"
        });
        if (!this.page) return;

        this.init();
    }

    renderQuestion(country) {
        return `<div class="flag" style="background-image: url(${getFlagPath(country.code)})"></div>`;
    }

    renderErrorItem(error) {
        return renderFlagDuelError(error);
    }
}
